var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgModalShade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 216,
    viewBox: "0 0 216 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1351_37580",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -120,
    y: -120,
    width: 336,
    height: 336
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 336,
    transform: "translate(-120 -120)",
    fill: "url(#paint0_radial_1351_37580)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1351_37580)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 47.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 47.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 71.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 95.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 119.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 143.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 167.5,
    stroke: "#EAECF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1351_37580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168 168) rotate(90) scale(168 168)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgModalShade);
export default __webpack_public_path__ + "static/media/bg-modal-shade.e16b4fbd0de651a7b557c5d36c603c4f.svg";
export { ForwardRef as ReactComponent };